<template>
	<div>
		<div class="sticky-container" v-if="loaded">
			<table class="table table-sm text-sm table-bordered table-timetable" :class="tableClass">
				<thead>
					<tr>
						<th></th>
						<th></th>
						<th v-for="(day,i) in days" :key="i" :colspan="day.periods.length">
							{{day.day}} /
							{{day.month}}
						</th>
					</tr>
					<tr>
						<th>Room</th>
						<th>Capacity</th>
						<template v-for="day in days">
							<th v-for="period in day.periods" :key="period.time">
								{{period.name}}
							</th>
						</template>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(room, i) in rooms" :key="i">
						<td>{{ room.ttroom_name }}</td>
						<td>
							{{ room.ttroom_clinicalcapacity }}:{{ room.ttroom_capacity }}
						</td>
						<template v-for="day in days">
							<template v-for="period in day.periods">
								<template v-if="period.time in room.events">
									<td :key="period.time" :class="{'td-danger': ((room.ttroom_clinicalcapacity && room.events[period.time].clinical_usage>room.ttroom_clinicalcapacity) || (room.ttroom_capacity && room.events[period.time].other_usage>room.ttroom_capacity))}">
										{{room.events[period.time].usage}}
										({{room.events[period.time].clinical_usage}}:{{room.events[period.time].other_usage}})
									</td>
								</template>
								<template v-else>
									<td :key="period.time" style="min-width: 100px" @click="addEvent(session)"></td>
								</template>
							</template>
						</template>
					</tr>
				</tbody>
			</table>
		</div>
		<template v-else>
			<div>
				<div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n"></div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			loaded: false,
			students: [],
			days: [],
			timetable: []
		}
	},
	mounted() {
		if (this.isNew) {
			this.loaded = true;
			this.startEditing();
		} else {
			this.loadTimetable();
		}
	},
	methods: {
		loadTimetable: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttimetable/getroomusage`, {
				data: {
					tttimetable_id: this.$route.params["timetableid"]
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.days = res.result.days;
					this.rooms = res.result.rooms;
					this.loaded = true;
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});
		}
	},
	computed: {
		tableClass: function(){
			if(Object.keys(this.timetable).length > 25){
				return 'table-timetable-sm'
			}
			return '';
		}
	}
};
</script>
